
export default {
  props: {
    img: {
      type: String,
      default: ''
    },
    names: {
      type: Array,
      default: () => []
    },
    path: {
      type: String,
      default: ''
    }
  },
  name: "classify",
  data() {
    return {

    }
  },
  methods: {
    linkHandler(path) {
      if(!path) return
      this.$router.push({
        path: path
      })
    }
  }
}
